@if (sectionsContainer) {
  <form [formGroup]="sectionsContainer.formGroup">
    <app-edit-fields
      [sectionsContainer]="sectionsContainer"
      [object]="sectionsContainer.rootObject"
      [fields]="sectionsContainer.primeFields"
    ></app-edit-fields>
  </form>
}
